import { jsx as r } from "react/jsx-runtime";
import { SvgIcon as c } from "../SvgIcon.js";
const t = (o) => /* @__PURE__ */ r(c, { ...o, children: /* @__PURE__ */ r("path", { d: "M17.4384 15.0524 11.011 3.93144c-.4307-.73993-1.49085-.73993-1.92155 0L2.67311 15.0524c-.41966.7399.11043 1.6565.96079 1.6565h12.8437c.8504 0 1.3805-.9166.9608-1.6565Zm-6.5599-.0221H9.21093v-1.6676h1.66757v1.6676Zm0-3.3242H9.21093V6.70338h1.66757v5.00272Z" }) });
export {
  t as Error
};
//# sourceMappingURL=Error.js.map
